<template>
  <div class="login-container">
    <!-- 左侧品牌展示区 -->
    <div class="brand-section">
      <div class="brand-content">
        <div class="logo-area">
          <div class="logo-icon">📋</div>
          <div class="logo-text">
            <h1>多人填表</h1>
            <p>数据管理平台</p>
          </div>
        </div>
        <div class="slogan">
          <p class="slogan-main">简单易用的个性化</p>
          <p class="slogan-sub">数据收集服务</p>
        </div>
        <!-- 特性标签 -->
        <div class="feature-tags">
          <span class="tag"><i class="el-icon-check"></i> 多人协作</span>
          <span class="tag"><i class="el-icon-check"></i> 实时同步</span>
          <span class="tag"><i class="el-icon-check"></i> 数据安全</span>
        </div>
        <!-- 轮播图 -->
        <div class="carousel-box">
          <el-carousel :interval="3000" height="200px" indicator-position="outside">
            <el-carousel-item v-for="(image,index) in images" :key="index">
              <el-image :src="images[index]" fit="contain" class="carousel-img"></el-image>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>

    <!-- 右侧登录区 -->
    <div class="login-section">
      <div class="login-box">
        <div class="login-header">
          <h2>欢迎登录</h2>
          <p>请使用小程序扫码快速登录</p>
        </div>

        <div class="login-btn-wrapper">
          <el-button class="wechat-login-btn" @click="scanLogin()">
            <span class="btn-icon">📱</span>
            <span class="btn-text">小程序扫码登录</span>
          </el-button>
        </div>

        <div class="divider">
          <span>登录说明</span>
        </div>

        <div class="steps-box">
          <div class="step">
            <span class="step-num">1</span>
            <span class="step-text">点击上方按钮打开二维码</span>
          </div>
          <div class="step">
            <span class="step-num">2</span>
            <span class="step-text">使用多人填表小程序扫码</span>
          </div>
        </div>

        <div class="help-link">
          <el-button @click="howToSwitch" type="text">
            <i class="el-icon-question"></i> 扫码遇到问题？切换浏览器模式
          </el-button>
        </div>
      </div>

      <!-- 底部备案 -->
      <div class="footer">
        <p>© 智韬科技 · ICP备案号：<a href="https://beian.miit.gov.cn" target="_blank">陇ICP备19004729号-2</a></p>
        <p class="beian-line">
          <img src="https://www.51tianbiao.com/form/images/gongan_beian_logo.png" />
          <a href="https://beian.mps.gov.cn/#/query/webSearch?code=62010202004354" target="_blank">甘公网安备62010202004354号</a>
        </p>
      </div>
    </div>

    <!--模式切换帮助-->
    <el-dialog width="80%" :close-on-click-modal="false" title="如何切换浏览器的模式" :visible.sync="browserSwitchDialogVisible">
      <div class="colStyle">
        如下图所示找到红色框的部分，点击一下，切换到闪电图标上或者是"极速模式"或"高速模式"
        <br /><br />
        <img src="../assets/switch_browser.png" width="100%" />
        <br /><br />
        正确的应该是如下图所示：
        <br /><br />
        <img src="../assets/good_browser.png" width="100%" />
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="browserSwitchDialogVisible=false">我知道了</el-button>
      </div>
    </el-dialog>

    <!--扫码登录-->
    <el-dialog :close-on-click-modal="false" :visible.sync="scanLoginDialogVisible" :before-close="beforeClose"
      custom-class="scan-login-dialog" width="700px">
      <div class="scan-login-wrapper">
        <!-- 横向排列：步骤流程 -->
        <div class="scan-flow">
          <div class="flow-item">
            <div class="flow-icon">
              <i class="el-icon-mobile-phone"></i>
            </div>
            <div class="flow-text">打开小程序</div>
          </div>
          <div class="flow-arrow">
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="flow-item">
            <div class="flow-icon">
              <i class="el-icon-full-screen"></i>
            </div>
            <div class="flow-text">点击扫码登录</div>
          </div>
          <div class="flow-arrow">
            <i class="el-icon-arrow-right"></i>
          </div>
          <div class="flow-item active">
            <div class="flow-icon">
              <i class="el-icon-check"></i>
            </div>
            <div class="flow-text">完成登录</div>
          </div>
        </div>

        <!-- 横向排列：主要内容区 -->
        <div class="scan-main">
          <!-- 左侧：说明文字 -->
          <div class="scan-instruction">
            <h3>📱 小程序扫码登录</h3>
            <div class="instruction-list">
              <div class="instruction-item">
                <span class="item-badge">1</span>
                <span>打开微信搜索"多人填表"小程序</span>
              </div>
              <div class="instruction-item">
                <span class="item-badge">2</span>
                <span>进入"更多功能"页面</span>
              </div>
              <div class="instruction-item">
                <span class="item-badge">3</span>
                <span>点击"扫码登录电脑"</span>
              </div>
              <div class="instruction-item">
                <span class="item-badge">4</span>
                <span>对准右侧二维码扫描</span>
              </div>
            </div>
            <div class="instruction-notice">
              <i class="el-icon-info"></i>
              <span>手机端功能更丰富，推荐使用手机操作</span>
            </div>
            <el-button @click="howToSwitch" type="text" class="instruction-help">
              <i class="el-icon-question"></i> 扫码失败？切换浏览器模式
            </el-button>
          </div>

          <!-- 右侧：二维码 -->
          <div class="scan-qrcode-area">
            <div class="qrcode-card">
              <div class="qrcode-title">小程序扫码登录</div>
              <div class="qrcode-image-box">
                <img :src="tmp_url" class="qrcode-img" />
              </div>
              <div class="qrcode-status">
                <span class="status-pulse"></span>
                <span class="status-text">等待小程序扫码...</span>
              </div>
            </div>
            <div class="qrcode-refresh-tip">
              <i class="el-icon-refresh"></i> 如二维码不显示，请刷新页面重试
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <!--扫码下载文件-->
    <el-dialog width="40%" :close-on-click-modal="false" title="扫码下载文件" :visible.sync="scanDownloadDialogVisible"
      :before-close="beforeClose">

      <div style="display: flex;justify-content: center;align-items: center;">
        <div style="width: 50%;">
          <div>要下载哪个表格,就在<span style="font-weight: bold;color:red;">多人填表小程序</span>上"<span style="font-weight: bold;">导出excel</span>"成功提示的页面上,点"扫码用电脑下载"扫描右侧的二维码下载。</div>
          <div style="margin-top: 20px;color: red;">如果扫码后无法下载，请刷新当前网页后再扫码。</div>
        </div>

        <div>
          <img :src="download_qrcode_url" style="width: 200px;height: 200px;" />
        </div>
      </div>

      <div v-show="download_file_url" style="margin-left: 20px;">
        <div style="font-size: 18px;font-weight: bold;">传输成功,请点击下面的链接下载文件！</div>
        <div>{{download_file_url}}</div>
        <div>
          <el-button @click="downloadFile()" type="success">立即下载文件</el-button>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeDownload">关闭</el-button>
      </div>
    </el-dialog>

    <!--测试登录-->
    <el-dialog width="30%" :close-on-click-modal="false" title="测试登录" :visible.sync="testDialogVisible"
      :before-close="beforeClose">
      <div style="display: flex;justify-content: left;align-items: center;">

        <el-form :model="loginForm" status-icon ref="loginForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="手机号" prop="username">
            <el-input type="text" v-model="loginForm.username" autocomplete="off" placeholder="输入手机号,和手机端相同">
            </el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input type="password" v-model="loginForm.password" @keyup.enter.native="submitForm('loginForm')"
              autocomplete="off" placeholder="输入密码,和手机端相同"></el-input>
          </el-form-item>

        </el-form>

      </div>

      <div slot="footer" class="dialog-footer">
        <div style="display: flex;justify-content: center;">
          <el-button type="primary" @click="submitForm('loginForm')">登录</el-button>
          <el-button type="primary" @click="cancelTestLogin">取消</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>
<script>
  export default {
    data() {
      return {
        browserSwitchDialogVisible: false,
        loginForm: {
          username: '',
          password: '',
          qrcode_url: '/form/web/_qrcode.jsp'
        },

        images: [
          '/form/hompage_images/p1.jpg',
          '/form/hompage_images/p2.jpg',
          '/form/hompage_images/p3.jpg',
          '/form/hompage_images/p4.jpg',
          '/form/hompage_images/p5.jpg'
        ],

        scanLoginDialogVisible: false,
        timer: null,

        scanDownloadDialogVisible: false,
        showDownloadLink: false,
        download_file_url: '',
        login_qrcode_url: '/form/web/_qrcode.jsp',
        login_qrcode_image_url: '',
        download_qrcode_url: '/form/web/_download_qrcode.jsp',

        testDialogVisible: false,

        tmp_url: '',
        tmp_url_ex: ''
      }
    },
    beforeDestroy() {
      clearInterval(this.timer)
    },
    created() {
      this.$session.set('USERNAME', '') // 存session
      this.$session.set('NAME', '') // 存session

      var timestamp = new Date().getTime()

      this.tmp_url = this.login_qrcode_url + '?t=' + timestamp
      this.tmp_url_ex = this.login_qrcode_url_create_image + '?t=' + timestamp

      var requestUrl = this.login_qrcode_url_create_image

      let that = this
      // console.log('mounted%%%%%%%%%%%%%%%%%%%%%', requestUrl)
      this.axios.get(requestUrl, {
        params: {}
      }).then(function(response) {
        that.login_qrcode_image_url = '/form' + response.data.url_qrcode_filename
       // console.log('&&&&&&&&', that.login_qrcode_image_url)
      })
    },

    methods: {
      submitForm(formName) {
        let that = this

        if (this.loginForm.username === '') {
          that.$message.error('请输入手机号')
          return
        }

        if (this.loginForm.password === '') {
          that.$message.error('请输入密码')
          return
        }

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/form/web/_login.jsp'

        this.axios.get(requestUrl, {
            params: {
              username: that.loginForm.username,
              password: that.loginForm.password
            }
          }).then(function(response) {
            console.log(response.data.result)
            var result = response.data.result
            if (result === '0') {
              that.$session.set('USERNAME', that.loginForm.username) // 存session
              that.$session.set('NAME', response.data.name) // 存session

              // that.$router.push('/exam_list')

              that.$router.push({
                path: '/form_list',
                params: {
                  username: that.loginForm.username
                }
              })
            } else {
              var tip = response.data.password_tip
              if (tip === '') {
                that.$message.error('账号错误,登录失败！')
              } else {
                that.$message.error('密码错误,登录失败！密码提示:' + tip)
              }
            }

            load.close()
          })
          .catch(err => {
            that.$message.error('登录失败，网络异常请稍后重试！')
            console.log(err)
            load.close()
          })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields()
      },
      registe() {
        this.$router.push('/registe')
      },
      howToSwitch() {
        this.browserSwitchDialogVisible = true
      },
      enterFun() {

        // this.submitForm('loginForm')
      },
      forgotPassword() {
        this.$message.error('请用手机端多人填表小程序查看密码!')
      },
      scanLogin() {
        let that = this

        this.timer = setInterval(function() {
          // console.log(this.timer)

          // 执行内容this.timer
          var requestUrl = '/form/web/_query_login_state.jsp'

          that.axios.get(requestUrl, {
            params: {}
          }).then(function(res) {
            var usr = res.data.username

            if (res.data.result === '1') {
              that.$session.set('USERNAME', usr)
              clearInterval(that.timer)

              that.$router.push({
                path: '/form_list',
                params: {
                  username: usr
                }
              })
            } else {}
          })
        }, 1000)
        this.scanLoginDialogVisible = true
      },
      closeScan() {
        clearInterval(this.timer)
        this.scanLoginDialogVisible = false
      },
      beforeClose() {
        this.closeScan()
      },
      scanDownload() {
        let that = this

        var timestamp = new Date().getTime()

        this.download_qrcode_url = this.download_qrcode_url + '?t=' + timestamp

        this.timer = setInterval(function() {
          // console.log(this.timer)

          // 执行内容this.timer
          var requestUrl = '/form/web/_query_download_state.jsp'

          that.axios.get(requestUrl, {
            params: {}
          }).then(function(res) {
            if (res.data.result === '1') {
              var download_file_url = res.data.download_file_url
              clearInterval(that.timer)

              that.download_file_url = download_file_url

              this.$message.success('文件已经传输成功，请点下载文件按钮下载！')

              console.log(download_file_url)

              // that.$router.push({
              //   path: '/download_file',
              //   params: {
              //     username: usr
              //   }
              // })
            } else {}
          })
        }, 1000)
        this.download_file_url = ''
        this.scanDownloadDialogVisible = true
      },
      closeDownload() {
        clearInterval(this.timer)
        this.scanDownloadDialogVisible = false
      },
      downloadFile() {
        window.open(this.download_file_url)
      },
      testLogin() {
        // console.log('*******')
        this.testDialogVisible = true
      },
      cancelTestLogin() {
        this.testDialogVisible = false
      }

    }
  }
</script>

<style scoped>
  .login-container {
    display: flex;
    min-height: 100vh;
    background: #fff;
  }

  /* 左侧品牌区 - 渐变背景 */
  .brand-section {
    flex: 1;
    background: linear-gradient(135deg, #1485FB 0%, #0066cc 50%, #0052a3 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px;
    position: relative;
    overflow: hidden;
  }

  /* 装饰性圆形 */
  .brand-section::before {
    content: '';
    position: absolute;
    top: -100px;
    right: -100px;
    width: 400px;
    height: 400px;
    background: rgba(255,255,255,0.05);
    border-radius: 50%;
  }

  .brand-section::after {
    content: '';
    position: absolute;
    bottom: -150px;
    left: -100px;
    width: 500px;
    height: 500px;
    background: rgba(255,255,255,0.03);
    border-radius: 50%;
  }

  .brand-content {
    position: relative;
    z-index: 1;
    max-width: 480px;
    color: #fff;
  }

  /* Logo区域 */
  .logo-area {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
  }

  .logo-icon {
    font-size: 48px;
    margin-right: 16px;
  }

  .logo-text h1 {
    font-size: 36px;
    font-weight: 700;
    margin: 0;
    letter-spacing: 2px;
  }

  .logo-text p {
    font-size: 16px;
    margin: 4px 0 0;
    opacity: 0.9;
    letter-spacing: 4px;
  }

  /* 标语 */
  .slogan {
    margin-bottom: 30px;
  }

  .slogan-main {
    font-size: 28px;
    font-weight: 300;
    margin: 0 0 8px;
  }

  .slogan-sub {
    font-size: 28px;
    font-weight: 600;
    margin: 0;
  }

  /* 特性标签 */
  .feature-tags {
    display: flex;
    gap: 16px;
    margin-bottom: 40px;
    flex-wrap: wrap;
  }

  .tag {
    background: rgba(255,255,255,0.15);
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 14px;
    backdrop-filter: blur(10px);
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .tag i {
    color: #2CCB92;
    font-weight: bold;
  }

  /* 轮播图 */
  .carousel-box {
    background: rgba(255,255,255,0.1);
    border-radius: 16px;
    padding: 20px;
    backdrop-filter: blur(10px);
  }

  .carousel-img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }

  ::v-deep .el-carousel__indicators {
    margin-top: 10px;
  }

  ::v-deep .el-carousel__button {
    background: rgba(255,255,255,0.5);
  }

  ::v-deep .el-carousel__indicator.is-active .el-carousel__button {
    background: #fff;
  }

  /* 右侧登录区 */
  .login-section {
    width: 420px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 40px;
    background: #fafbfc;
  }

  .login-box {
    width: 100%;
    max-width: 340px;
  }

  .login-header {
    text-align: center;
    margin-bottom: 40px;
  }

  .login-header h2 {
    font-size: 28px;
    color: #1a1a1a;
    margin: 0 0 8px;
    font-weight: 600;
  }

  .login-header p {
    font-size: 14px;
    color: #888;
    margin: 0;
  }

  /* 登录按钮 */
  .login-btn-wrapper {
    margin-bottom: 30px;
  }

  .wechat-login-btn {
    width: 100%;
    height: 52px;
    font-size: 16px;
    border-radius: 8px;
    background: #2CCB92;
    border: none;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(44, 203, 146, 0.3);
  }

  .wechat-login-btn:hover {
    background: #25b582;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(44, 203, 146, 0.4);
  }

  .btn-icon {
    font-size: 20px;
  }

  .btn-text {
    font-weight: 500;
  }

  /* 分隔线 */
  .divider {
    display: flex;
    align-items: center;
    margin: 24px 0;
    color: #bbb;
    font-size: 13px;
  }

  .divider::before,
  .divider::after {
    content: '';
    flex: 1;
    height: 1px;
    background: #e8e8e8;
  }

  .divider span {
    padding: 0 16px;
  }

  /* 步骤说明 */
  .steps-box {
    background: #fff;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 20px;
    border: 1px solid #f0f0f0;
  }

  .step {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
  }

  .step:last-child {
    margin-bottom: 0;
  }

  .step-num {
    width: 24px;
    height: 24px;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    margin-right: 12px;
    flex-shrink: 0;
  }

  .step-text {
    font-size: 14px;
    color: #555;
  }

  /* 帮助链接 */
  .help-link {
    text-align: center;
  }

  .help-link ::v-deep .el-button {
    color: #888;
    font-size: 13px;
  }

  .help-link ::v-deep .el-button:hover {
    color: #1485FB;
  }

  /* 底部备案 */
  .footer {
    position: absolute;
    bottom: 20px;
    text-align: center;
    font-size: 12px;
    color: #aaa;
  }

  .footer p {
    margin: 4px 0;
  }

  .footer a {
    color: #888;
    text-decoration: none;
  }

  .footer a:hover {
    color: #1485FB;
  }

  .beian-line {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }

  .beian-line img {
    width: 14px;
    height: 14px;
  }

  /* ==================== 扫码登录弹窗样式 ==================== */
  /* 弹窗整体 */
  ::v-deep .scan-login-dialog .el-dialog__header {
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    padding: 20px 30px;
  }

  ::v-deep .scan-login-dialog .el-dialog__title {
    color: #fff;
    font-size: 18px;
    font-weight: 600;
  }

  ::v-deep .scan-login-dialog .el-dialog__headerbtn .el-dialog__close {
    color: rgba(255,255,255,0.8);
  }

  ::v-deep .scan-login-dialog .el-dialog__headerbtn:hover .el-dialog__close {
    color: #fff;
  }

  ::v-deep .scan-login-dialog .el-dialog__body {
    padding: 0;
  }

  ::v-deep .scan-login-dialog .el-dialog__footer {
    border-top: 1px solid #f0f0f0;
    padding: 15px 30px;
  }

  .scan-login-wrapper {
    padding: 30px;
  }

  /* 流程步骤条 - 横向 */
  .scan-flow {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
    padding: 20px;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 12px;
  }

  .flow-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  .flow-icon {
    width: 48px;
    height: 48px;
    background: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: #888;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    border: 2px solid #e8e8e8;
  }

  .flow-item.active .flow-icon {
    background: linear-gradient(135deg, #2CCB92 0%, #25b582 100%);
    color: #fff;
    border-color: #2CCB92;
  }

  .flow-text {
    font-size: 13px;
    color: #666;
    font-weight: 500;
  }

  .flow-item.active .flow-text {
    color: #2CCB92;
  }

  .flow-arrow {
    margin: 0 20px;
    color: #ccc;
    font-size: 18px;
  }

  /* 主要内容区 - 左右分栏 */
  .scan-main {
    display: flex;
    gap: 30px;
  }

  /* 左侧说明 */
  .scan-instruction {
    flex: 1;
    padding: 10px;
  }

  .scan-instruction h3 {
    font-size: 18px;
    color: #1a1a1a;
    margin: 0 0 20px;
    padding-bottom: 15px;
    border-bottom: 2px solid #f0f0f0;
  }

  .instruction-list {
    margin-bottom: 20px;
  }

  .instruction-item {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    font-size: 14px;
    color: #555;
  }

  .item-badge {
    width: 24px;
    height: 24px;
    background: linear-gradient(135deg, #1485FB 0%, #0d6efd 100%);
    color: #fff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    margin-right: 12px;
    flex-shrink: 0;
  }

  .instruction-notice {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: #e6f7ff;
    border-radius: 8px;
    font-size: 13px;
    color: #1485FB;
    margin-bottom: 15px;
  }

  .instruction-help {
    color: #888 !important;
    font-size: 13px;
  }

  .instruction-help:hover {
    color: #1485FB !important;
  }

  /* 右侧二维码区 */
  .scan-qrcode-area {
    width: 240px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .qrcode-card {
    background: #fff;
    border-radius: 16px;
    padding: 20px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.08);
    border: 1px solid #f0f0f0;
    text-align: center;
    width: 100%;
  }

  .qrcode-title {
    font-size: 14px;
    color: #666;
    margin-bottom: 15px;
    font-weight: 500;
  }

  .qrcode-image-box {
    width: 180px;
    height: 180px;
    margin: 0 auto 15px;
    border: 2px dashed #e0e0e0;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .qrcode-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .qrcode-status {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 13px;
    color: #888;
  }

  .status-pulse {
    width: 8px;
    height: 8px;
    background: #2CCB92;
    border-radius: 50%;
    animation: pulse 2s infinite;
  }

  @keyframes pulse {
    0% { box-shadow: 0 0 0 0 rgba(44, 203, 146, 0.4); }
    70% { box-shadow: 0 0 0 10px rgba(44, 203, 146, 0); }
    100% { box-shadow: 0 0 0 0 rgba(44, 203, 146, 0); }
  }

  .qrcode-refresh-tip {
    margin-top: 15px;
    font-size: 12px;
    color: #999;
    text-align: center;
  }

  .qrcode-refresh-tip i {
    margin-right: 4px;
  }

  /* 响应式 */
  @media (max-width: 900px) {
    .login-container {
      flex-direction: column;
    }

    .brand-section {
      min-height: 300px;
      padding: 30px;
    }

    .brand-content {
      text-align: center;
    }

    .logo-area {
      justify-content: center;
    }

    .feature-tags {
      justify-content: center;
    }

    .carousel-box {
      display: none;
    }

    .login-section {
      width: 100%;
      min-height: 400px;
      padding: 30px 20px 60px;
    }

    .footer {
      position: relative;
      bottom: auto;
      margin-top: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue